import { useEffect, useState } from "react";
import Eye from "../assets/search.png";
import TrendingUp from "../assets/trend.png";
import ShoppingBag from "../assets/bag.png";
import Banknote from "../assets/money.png";

const PlatformCard = ({ platform, active }) => {
  const [seoAnalyses, setSeoAnalyses] = useState([]);
  const analysis = platform.analyses[0] || {};

  // Fetch SEO analyses from API
  useEffect(() => {
    const fetchSeoAnalyses = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          "http://backend.goldensection.agency/public/api/myinfo",
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        const data = await res.json();
        console.log("Full API response:", data);

        // جرّب هل seos جوا users أو برا
        if (data.users && data.users[0] && data.users[0].seos) {
          console.log("User Seos:", data.users[0].seos);
          setSeoAnalyses(data.users[0].seos);
        } else if (data.seos) {
          console.log("Root Seos:", data.seos);
          setSeoAnalyses(data.seos);
        }
      } catch (err) {
        console.error("Error fetching SEO analyses:", err);
      }
    };

    if (platform.type === "seo") {
      fetchSeoAnalyses();
    }
  }, [platform.type]);

  return (
    <>
      <div
        className="platform-card"
        style={{
          backgroundColor: active ? `${platform.color}22` : "#fff",
          borderColor: active ? platform.color : "#ccc",
        }}
      >
        <img src={platform.logo} alt={platform.name} className="card-logo" />
        <h3 style={{ color: "#000" }}>{platform.name}</h3> {/* Social Media */}
        {platform.type === "social" && (
          <div className="platform-number">
            <div className="cards_number">
              {analysis.revenue != null && (
                <div className="card_number">
                  <img src={TrendingUp} alt="" />
                  <h6>العوائد</h6>
                  <p>
                    <b>{analysis.revenue}</b>
                  </p>
                </div>
              )}
              {analysis.spending != null && (
                <div className="card_number">
                  <img src={Banknote} alt="" />
                  <h6>الصرف</h6>
                  <p>
                    <b>{analysis.spending}</b>
                  </p>
                </div>
              )}
              {analysis.impressions != null && (
                <div className="card_number">
                  <img src={Eye} alt="" />
                  <h6>مرات الظهور</h6>
                  <p>
                    <b>{analysis.impressions}</b>
                  </p>
                </div>
              )}
              {analysis.orders != null && (
                <div className="card_number">
                  <img src={ShoppingBag} alt="" />
                  <h6>الطلبات</h6>
                  <p>
                    <b>{analysis.orders}</b>
                  </p>
                </div>
              )}
            </div>

            <table className="big_table">
              <thead>
                <tr>
                  {analysis.roi != null && <th>العائد على الاستثمار</th>}
                  {analysis.checkout_page_visits != null && (
                    <th>الوصول لصفحة اتمام الطلب</th>
                  )}
                  {analysis.cpc != null && <th>تكلفة النقرة</th>}
                  {analysis.cpa != null && <th>تكلفة جلب الطلب</th>}
                  {analysis.cart_additions != null && <th>عدد اضافات للسلة</th>}
                  {analysis.clicks != null && <th>عدد النقرات</th>}
                  {analysis.impressions != null && <th>عدد مرات الظهور</th>}
                  {analysis.ctr != null && <th>نسبة النقر للظهور</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.roi != null && <td>{analysis.roi}</td>}
                  {analysis.checkout_page_visits != null && (
                    <td>{analysis.checkout_page_visits}</td>
                  )}
                  {analysis.cpc != null && <td>{analysis.cpc}</td>}
                  {analysis.cpa != null && <td>{analysis.cpa}</td>}
                  {analysis.cart_additions != null && (
                    <td>{analysis.cart_additions}</td>
                  )}
                  {analysis.clicks != null && <td>{analysis.clicks}</td>}
                  {analysis.impressions != null && (
                    <td>{analysis.impressions}</td>
                  )}
                  {analysis.ctr != null && <td>{analysis.ctr}</td>}
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {/* WhatsApp */}
        {platform.type === "whatsapp" && (
          <div className="platform-number">
            <table className="big_table">
              <thead>
                <tr>
                  <th>فترة الحملة</th>
                  <th>اسم الكود</th>
                  <th>عدد العملاء</th>
                  <th>المبيعات</th>
                </tr>
              </thead>
              <tbody>
                {platform.analyses.map((c) => (
                  <tr key={c.id}>
                    <td>{c.period}</td>
                    <td>{c.code_name}</td>
                    <td>{c.customer}</td>
                    <td>{c.sales}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* SEO */}
        {platform.type === "seo" && (
          <div className="platform-number">
            {/* الجدول الأساسي للـ SEO */}
            <table className="big_table" style={{ backgroundColor: "#F5DEB3" }}>
              <thead>
                <tr>
                  {analysis.keywords_count != null && (
                    <th>عدد الكلمات المفتاحية المتصدرة</th>
                  )}
                  {analysis.impressions_count != null && (
                    <th>عدد مرات الظهور العضوي</th>
                  )}
                  {(analysis.clicks_count != null ||
                    analysis.impressions_count != null) && (
                    <th>مرات النقر والظهور</th>
                  )}
                  {analysis.articles_count != null && (
                    <th>عدد المقالات المكتوبة</th>
                  )}
                  {analysis.product_descriptions_count != null && (
                    <th>عدد وصف المنتجات المكتوبة</th>
                  )}
                  {analysis.updated_articles_count != null && (
                    <th>عدد المقالات المحدثة</th>
                  )}
                  {analysis.seo_products_count != null && (
                    <th>عدد المنتجات الخاصة بتحسين السيو</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.keywords_count != null && (
                    <td>{analysis.keywords_count}</td>
                  )}
                  {analysis.impressions_count != null && (
                    <td>{analysis.impressions_count}</td>
                  )}
                  {(analysis.clicks_count != null ||
                    analysis.impressions_count != null) && (
                    <td>
                      {analysis.clicks_count || 0} /{" "}
                      {analysis.impressions_count || 0}
                    </td>
                  )}
                  {analysis.articles_count != null && (
                    <td>{analysis.articles_count}</td>
                  )}
                  {analysis.product_descriptions_count != null && (
                    <td>{analysis.product_descriptions_count}</td>
                  )}
                  {analysis.updated_articles_count != null && (
                    <td>{analysis.updated_articles_count}</td>
                  )}
                  {analysis.seo_products_count != null && (
                    <td>{analysis.seo_products_count}</td>
                  )}
                </tr>
              </tbody>
            </table>

            {/* الجزء الجديد للـ SEO من API */}
            {seoAnalyses.length > 0 &&
              seoAnalyses.map(
                (seoItem) =>
                  seoItem.analyses &&
                  seoItem.analyses.length > 0 && (
                    <div
                      key={seoItem.id}
                      className="seo-extra"
                      style={{ marginTop: "20px" }}
                    >
                      {seoItem.analyses.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            marginBottom: "20px",
                            padding: "15px",
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            background: "#fff",
                            textAlign: "center",
                          }}
                        >
                          <h2 style={{ marginBottom: "10px" }}>{item.title}</h2>
                          <p
                            style={{ textAlign: "right", marginBottom: "15px" }}
                          >
                            {item.description}
                          </p>
                          {item.image && (
                            <img
                              src={`http://backend.goldensection.agency/public/api/${item.image}`}
                              alt={item.title}
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "10px",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ),
              )}
          </div>
        )}
      </div>

      <div
        style={{
          backgroundColor: active ? `${platform.color}22` : "#fff",
          borderColor: active ? platform.color : "#ccc",
        }}
        className="cardmobile"
      >
        <img src={platform.logo} alt={platform.name} className="card-logo" />
        <h3 style={{ color: "#000" }}>{platform.name}</h3> {/* Social Media */}
        {platform.type === "social" && (
          <div className="platform-number">
            <div className="cards_number">
              {analysis.revenue != null && (
                <div className="card_number">
                  <img src={TrendingUp} alt="" />
                  <h6>العوائد</h6>
                  <p>
                    <b>{analysis.revenue}</b>
                  </p>
                </div>
              )}
              {analysis.spending != null && (
                <div className="card_number">
                  <img src={Banknote} alt="" />
                  <h6>الصرف</h6>
                  <p>
                    <b>{analysis.spending}</b>
                  </p>
                </div>
              )}
              {analysis.impressions != null && (
                <div className="card_number">
                  <img src={Eye} alt="" />
                  <h6>مرات الظهور</h6>
                  <p>
                    <b>{analysis.impressions}</b>
                  </p>
                </div>
              )}
              {analysis.orders != null && (
                <div className="card_number">
                  <img src={ShoppingBag} alt="" />
                  <h6>الطلبات</h6>
                  <p>
                    <b>{analysis.orders}</b>
                  </p>
                </div>
              )}
            </div>

            {/* الجدول الأول */}
            <table className="big_table">
              <thead>
                <tr>
                  {analysis.roi != null && <th>العائد على الاستثمار</th>}
                  {analysis.checkout_page_visits != null && (
                    <th>الوصول لصفحة اتمام الطلب</th>
                  )}
                  {analysis.cpc != null && <th>تكلفة النقرة</th>}
                  {analysis.cpa != null && <th>تكلفة جلب الطلب</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.roi != null && <td>{analysis.roi}</td>}
                  {analysis.checkout_page_visits != null && (
                    <td>{analysis.checkout_page_visits}</td>
                  )}
                  {analysis.cpc != null && <td>{analysis.cpc}</td>}
                  {analysis.cpa != null && <td>{analysis.cpa}</td>}
                </tr>
              </tbody>
            </table>

            {/* الجدول الثاني */}
            <table className="big_table">
              <thead>
                <tr>
                  {analysis.cart_additions != null && <th>عدد اضافات للسلة</th>}
                  {analysis.clicks != null && <th>عدد النقرات</th>}
                  {analysis.impressions != null && <th>عدد مرات الظهور</th>}
                  {analysis.ctr != null && <th>نسبة النقر للظهور</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.cart_additions != null && (
                    <td>{analysis.cart_additions}</td>
                  )}
                  {analysis.clicks != null && <td>{analysis.clicks}</td>}
                  {analysis.impressions != null && (
                    <td>{analysis.impressions}</td>
                  )}
                  {analysis.ctr != null && <td>{analysis.ctr}</td>}
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {/* WhatsApp */}
        {platform.type === "whatsapp" && (
          <div className="platform-number">
            <table className="big_table">
              <thead>
                <tr>
                  <th>فترة الحملة</th>
                  <th>اسم الكود</th>
                  <th>عدد العملاء</th>
                  <th>المبيعات</th>
                </tr>
              </thead>
              <tbody>
                {platform.analyses.map((c) => (
                  <tr key={c.id}>
                    <td>{c.period}</td>
                    <td>{c.code_name}</td>
                    <td>{c.customer}</td>
                    <td>{c.sales}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {/* SEO */}
        {platform.type === "seo" && (
          <div className="platform-number">
            {/* الجدول الأساسي للـ SEO */}
            {/* الجدول الأول */}
            <table className="big_table" style={{ backgroundColor: "#F5DEB3" }}>
              <thead>
                <tr>
                  {analysis.keywords_count != null && (
                    <th>عدد الكلمات المفتاحية المتصدرة</th>
                  )}
                  {analysis.impressions_count != null && (
                    <th>عدد مرات الظهور العضوي</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.keywords_count != null && (
                    <td>{analysis.keywords_count}</td>
                  )}
                  {analysis.impressions_count != null && (
                    <td>{analysis.impressions_count}</td>
                  )}
                </tr>
              </tbody>
            </table>

            {/* الجدول الثاني */}
            <table className="big_table" style={{ backgroundColor: "#F5DEB3" }}>
              <thead>
                <tr>
                  {(analysis.clicks_count != null ||
                    analysis.impressions_count != null) && (
                    <th>مرات النقر والظهور</th>
                  )}
                  {analysis.articles_count != null && (
                    <th>عدد المقالات المكتوبة</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {(analysis.clicks_count != null ||
                    analysis.impressions_count != null) && (
                    <td>
                      {analysis.clicks_count || 0} /{" "}
                      {analysis.impressions_count || 0}
                    </td>
                  )}
                  {analysis.articles_count != null && (
                    <td>{analysis.articles_count}</td>
                  )}
                </tr>
              </tbody>
            </table>

            {/* الجدول الثالث */}
            <table className="big_table" style={{ backgroundColor: "#F5DEB3" }}>
              <thead>
                <tr>
                  {analysis.product_descriptions_count != null && (
                    <th>عدد وصف المنتجات المكتوبة</th>
                  )}
                  {analysis.updated_articles_count != null && (
                    <th>عدد المقالات المحدثة</th>
                  )}
                  {analysis.seo_products_count != null && (
                    <th>عدد المنتجات الخاصة بتحسين السيو</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {analysis.product_descriptions_count != null && (
                    <td>{analysis.product_descriptions_count}</td>
                  )}
                  {analysis.updated_articles_count != null && (
                    <td>{analysis.updated_articles_count}</td>
                  )}
                  {analysis.seo_products_count != null && (
                    <td>{analysis.seo_products_count}</td>
                  )}
                </tr>
              </tbody>
            </table>

            {/* الجزء الجديد للـ SEO من API */}
            {seoAnalyses.length > 0 &&
              seoAnalyses.map(
                (seoItem) =>
                  seoItem.analyses &&
                  seoItem.analyses.length > 0 && (
                    <div
                      key={seoItem.id}
                      className="seo-extra"
                      style={{ marginTop: "10px" }}
                    >
                      {seoItem.analyses.map((item) => (
                        <div
                          key={item.id}
                          style={{
                            marginBottom: "10px",
                            padding: "10px",
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            background: "#fff",
                            textAlign: "center",
                          }}
                        >
                          <h5 style={{ marginBottom: "5px" }}>{item.title}</h5>
                          <h6
                            style={{ textAlign: "right", marginBottom: "5px" }}
                          >
                            {item.description}
                          </h6>
                          {item.image && (
                            <img
                              src={`http://backend.goldensection.agency/public/api/${item.image}`}
                              alt={item.title}
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "10px",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ),
              )}
          </div>
        )}
      </div>
    </>
  );
};

export default PlatformCard;
